import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/MaskedLines";

const SECTIONS = [
  {
    title: "Who we are",
    body: "This website, meranggi.com, is operated by CV Meranggi Jaya (\u201cMeranggi\u201d, \u201cwe\u201d), a garment manufacturing company located at Jl. Raya Udayana, Kecamatan Blahbatuh, Kabupaten Gianyar, Bali 80581, Indonesia.",
  },
  {
    title: "What we collect",
    body: "This website does not use contact forms, accounts, tracking cookies, or analytics tools. We do not collect personal data through the site itself. If you contact us by email or telephone, we receive only the information you choose to share — typically your name, contact details and the details of your enquiry.",
  },
  {
    title: "How we use your information",
    body: "Information you send us is used solely to respond to your enquiry and, if it proceeds, to prepare quotations, samples and production for your order. We do not sell, rent or share your personal information with third parties for marketing purposes.",
  },
  {
    title: "Server logs",
    body: "Like most websites, our hosting provider may automatically record standard technical logs (such as IP address, browser type and pages visited) for security and operational purposes. These logs are not used to identify individual visitors.",
  },
  {
    title: "External services",
    body: "This site embeds Google Maps to show our factory location. When you interact with the map or follow external links, the privacy policies of those services apply.",
  },
  {
    title: "Your rights",
    body: "You may ask us at any time what personal information we hold about you, request a correction, or ask us to delete it. To do so, contact us at info@meranggi.com or (0361) 943614.",
  },
  {
    title: "Changes to this policy",
    body: "If this policy changes, the updated version will be published on this page. Last updated: July 2026.",
  },
];

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page-container" className="relative bg-white">
      <Navbar />
      <main className="mx-auto max-w-3xl px-5 pb-24 pt-32 sm:px-6 sm:pt-40">
        <Reveal>
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="group inline-flex items-center gap-1 text-sm text-[#0066cc] hover:underline"
          >
            <ChevronLeft size={16} className="transition-transform duration-200 group-hover:-translate-x-0.5" />
            Back to Meranggi
          </Link>

          <h1
            data-testid="privacy-title"
            className="mt-10 text-4xl font-semibold leading-[1.08] tracking-tight text-[#1d1d1f] sm:text-5xl"
          >
            Privacy Policy
          </h1>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-[#86868b]">
            The short version: this site collects nothing from you. If you write or call us, we use your details only
            to answer you.
          </p>
        </Reveal>

        <div data-testid="privacy-content" className="mt-14">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={0.04 * i}>
              <section data-testid={`privacy-section-${i + 1}`} className="border-t border-black/10 py-8">
                <h2 className="text-xl font-semibold tracking-tight text-[#1d1d1f] sm:text-2xl">{s.title}</h2>
                <p className="mt-3 text-sm leading-relaxed text-[#1d1d1f]/80 sm:text-base">{s.body}</p>
              </section>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-6 rounded-[24px] bg-[#f5f5f7] p-8">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#86868b]">Questions about this policy</p>
            <p className="mt-4 text-sm leading-relaxed text-[#1d1d1f]/80">
              CV Meranggi Jaya — Jl. Raya Udayana, Kecamatan Blahbatuh, Kabupaten Gianyar, Bali 80581, Indonesia
              <br />
              <a href="mailto:info@meranggi.com" data-testid="privacy-email-link" className="text-[#0066cc] hover:underline">
                info@meranggi.com
              </a>{" "}
              ·{" "}
              <a href="tel:+62361943614" data-testid="privacy-phone-link" className="text-[#0066cc] hover:underline">
                (0361) 943614
              </a>
            </p>
          </div>
        </Reveal>
      </main>
      <Footer />
    </div>
  );
}
